<template>
  <div class="animated fadeIn">
    <h2>ติดต่อเรา</h2>
    <b-card>
      <p>
        มีปัญหาการใช้งานหรือ
        ต้องการสอบถามข้อมูลเพิ่มเติมได้ที่
      </p>
      <p>
        <b>
          บริษัท โลจิสตี จำกัด
          <br />Email: hi.logisty@gmail.com
          <br />โทร: 099-287-1919, 099-285-5353
        </b>
      </p>
      <a href="https://www.logisty.asia" target="_blank">ดูเว็บไซต์</a>
    </b-card>
    <b-card>
      <p>
        สำหรับผู้ให้บริการขนส่งที่สนใจรับข้อมูลงานแบบ real-time ผ่านทางไลน์ สามารถแอดไลน์ <b>@LogistyCarrier</b> (มีสัญลักษณ์ @) หรือคลิก
        <a
          href="https://lin.ee/qSQaKeh"
          target="_blank"
        >
          <img
            src="https://scdn.line-apps.com/n/line_add_friends/btn/th.png"
            alt="เพิ่มเพื่อน"
            height="36"
            border="0"
          />
        </a>
      </p>
      <div>
        <img src="https://qr-official.line.me/sid/M/063glhfk.png">
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  mounted () {
    window.analytics.track('contactus-open')
  }
}
</script>
